import {Switch, Typography} from "antd";
import {Controller, useFormContext} from "react-hook-form";
import {ProductVariantsFormValues} from "../types";
import {ProductVariantsToggleFormFieldProps} from "./types";
import {StyledVariantsToggleWrapper} from "./styles";

export function ProductVariantsToggleFormFields({
  unavailableReason,
}: ProductVariantsToggleFormFieldProps) {
  const {control, clearErrors} = useFormContext<ProductVariantsFormValues>();
  const isUnavailable = !!unavailableReason;

  return (
    <StyledVariantsToggleWrapper>
      <Controller
        control={control}
        name="showVariants"
        render={({field: {value, onChange}}) => (
          // No tooltip on the reason: a disabled antd Switch emits no mouse events, so
          // one would never open. It is stated in the open text beside the control
          // instead, which is where the coach is already looking.
          <Switch
            onChange={(e) => {
              clearErrors("variants");
              onChange(e);
            }}
            checked={value && !isUnavailable}
            disabled={isUnavailable}
          />
        )}
      />
      <div>
        <p>
          Create optional product add-ons that customers can include with the main
          product. The add-on prices will be added to the total at checkout.
        </p>
        {isUnavailable && (
          <Typography.Text type="secondary">{unavailableReason}</Typography.Text>
        )}
      </div>
    </StyledVariantsToggleWrapper>
  );
}
